import { createContext, useContext, useState, ReactNode } from "react";
import type { Database } from "@/integrations/supabase/types";

type AppRole = Database["public"]["Enums"]["app_role"];

interface RolePreviewContextType {
  previewRole: AppRole | null;
  isInPreviewMode: boolean;
  startPreview: (role: AppRole) => void;
  exitPreview: () => void;
}

const RolePreviewContext = createContext<RolePreviewContextType | undefined>(undefined);

export function RolePreviewProvider({ children }: { children: ReactNode }) {
  const [previewRole, setPreviewRole] = useState<AppRole | null>(null);

  const startPreview = (role: AppRole) => {
    setPreviewRole(role);
  };

  const exitPreview = () => {
    setPreviewRole(null);
  };

  return (
    <RolePreviewContext.Provider
      value={{
        previewRole,
        isInPreviewMode: previewRole !== null,
        startPreview,
        exitPreview,
      }}
    >
      {children}
    </RolePreviewContext.Provider>
  );
}

export function useRolePreview() {
  const context = useContext(RolePreviewContext);
  if (context === undefined) {
    throw new Error("useRolePreview must be used within a RolePreviewProvider");
  }
  return context;
}
